import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $backgroundColor?: string }>`
    ${({ $backgroundColor }) => css`
        background: ${$backgroundColor};
    `}
`;
